<template>
  <div class="nf-card" :style="{ width }">
    <div
      class="nf-card_box"
      :class="{
        'nf-card_box_shadow': shadow,
      }"
      :style="{
        'border-width': borderSize,
        'border-radius': round,
        backgroundColor: bgColor,
        'border-style': border,
        'border-color': borderColor,
        padding,
      }"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    dash: {
      type: Boolean,
      default: true,
    },
    padding: {
      type: String,
      default: "0.1rem",
    },
    border: {
      type: String,
      default: "solid",
    },
    borderSize: {
      type: String,
      default: "0.01rem",
    },
    borderInner: {
      type: String,
      default: "dashed",
    },
    borderInnerSize: {
      type: String,
      default: "0.01rem",
    },
    round: {
      type: String,
      default: "0.1rem",
    },
    width: {
      type: String,
      default: "100%",
    },
    bgColor: {
      type: String,
      default: "",
    },
    borderColor: {
      type: String,
      default: "",
    },
    shadow: {
      type: Boolean,
      default: false,
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.nf-card {
  padding: 0.01rem;
  box-sizing: border-box;
  &_box {
    box-sizing: border-box;
    border: 0.05rem solid #e5e5e5;
    border-width: 0;
    border-radius: 0.1rem;
    overflow: hidden;
    padding: 0.02rem;
    &_solid {
      box-sizing: border-box;
    }
    &_dash {
      box-sizing: border-box;

      // 虚线
      border-radius: 0.1rem;
      border: 0.01rem dashed #e5e5e5;
    }
    &_shadow {
      box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.08);
    }
  }
}
</style>
